module.exports = __webpack_public_path__ + "media/lager-2.25500396.mp4";